<div class="table-container" @fade>
  <table mat-table [dataSource]="data" 
         class="my-data-table" 
         [class.compact]="compact"
         [class.presentation-minimal]="presentationMode === 'minimal'"
         [class.presentation-striped]="presentationMode === 'striped'"
         [class.presentation-cards]="presentationMode === 'cards'">
    <ng-container *ngFor="let column of columns" [matColumnDef]="column.key">
      <th mat-header-cell *matHeaderCellDef [class.sortable]="column.sortable" (click)="onSort(column)">
        {{ column.header }}
        <mat-icon *ngIf="column.sortable" class="sort-icon">
          {{ getSortIcon(column) }}
        </mat-icon>
      </th>
      <td mat-cell *matCellDef="let row" (click)="clickRow($event, row)">
        <div *ngIf="column.isDetails" class="details-cell">
          <div
            *ngFor="let field of column.fields; let i = index"
            [ngClass]="column.classes?.[i]"
            [title]="row?.[field]"
          >
            {{ row?.[field] }}
          </div>
        </div>
        <button
          *ngIf="column.isAction"
          mat-icon-button
          (click)="clickAction($event, row)"
          class="action-button"
          [matTooltip]="column.tooltip"
          [attr.aria-label]="column.tooltip"
        >
          <mat-icon class="action-icon">
            {{ getActionIcon(row, column) }}
          </mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Header and Row Definitions -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: stickyHeader"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{ 'selected-row': isSelected(row), 'presentation-mode-applied': true }"
        [@rowAnimation]="'in'"></tr>

    <!-- Empty state -->
    <tr class="mat-row empty-row" *matNoDataRow>
      <td class="mat-cell" [colSpan]="displayedColumns.length">
        <div class="empty-state">
          <mat-icon>inbox</mat-icon>
          <p>{{ emptyMessage || 'No data available' }}</p>
        </div>
      </td>
    </tr>
  </table>
</div>
